import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROPERTY_MODELS_BY_COMMUNITY } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetProps {
  communityId: string
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getActivePropertyModels = async (communityId: string) =>
  await axiosAuth.get(`${PROPERTY_MODELS_BY_COMMUNITY(communityId)}/active`);

const useGetActivePropertyModels = ({communityId, queryParams}: UseGetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-active-models", communityId],
    queryFn: () => getActivePropertyModels(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetActivePropertyModels;
